import React from 'react'
import { format } from 'date-fns'

import { getDaysOfWeek } from 'services/Dates'
import { Checkbox, Input, MultiSelect } from 'components/Forms'
import { Collapsable, AutomaticButtonGroup } from 'components/UI'

import { t } from 'translations'

const ShiftMultiCreation = ({ amountOfDay, currentDate, isCreating, isTemplate, multiDayIndex, rrule = {} }) => {
  if (!isCreating) return null

  // Function to get the available days to create similar shifts
  const getOtherDatesToCreate = () => {
    return new Array(amountOfDay).fill(1).map((option, index) => {
      const value = index
      const label = t('manager.scheduleTemplates.form.MULTIDAYINDEX.OPTION', { day: index + 1 })
      return {
        value,
        label,
        isDisabled: multiDayIndex === index
      }
    })
  }

  const moduleName = isTemplate ? 'manager.scheduleTemplates.form' : 'manager.schedule.eventForm'

  return (
    <Collapsable type="multiCreation" title={isTemplate ? 'manager.scheduleTemplates.form.MULTI_CREATION' : 'manager.schedule.eventForm.MULTI_CREATION'}>
      {/* Number of identical shifts to create */}
      <Input
        module={moduleName}
        name={isTemplate ? 'numberOfIdentical' : 'duplicateNumber'}
        min="0"
        step="1"
        max={rrule.frequency === 'NONE' ? 100 : 20}
        type="number"
      />
      {/* This option is only shown in weekly view  */}
      {amountOfDay > 1 && rrule.frequency === 'NONE' ? (
        <div className="mb-2">
          <AutomaticButtonGroup>
            {getDaysOfWeek(currentDate).map((day, index) => {
              return (
                <Checkbox
                  disabled={format(currentDate, 'EEEE') === day}
                  buttonCheckbox
                  module="components.recurrenceRule.form"
                  translation={day}
                  name={`addToOtherDays.byWeekDay.${index}`}
                  key={day}
                />
              )
            })}
          </AutomaticButtonGroup>
        </div>
      ) : null}
      {/* This option is only shown in multi-day template */}
      {amountOfDay > 1 && isTemplate ? (
        <MultiSelect module={moduleName} name="addToOtherDays" isClearable isMulti closeMenuOnSelect={false} options={getOtherDatesToCreate()} />
      ) : null}
    </Collapsable>
  )
}

export default ShiftMultiCreation
